var map = {
	"./Loading-Icon.gif": 800,
	"./app-awareness-phone.png": 359,
	"./app-modal-android@2x.png": 601,
	"./app-modal-iphone@2x.png": 602,
	"./app-promo-banner-background.png": 801,
	"./box-prices/best-value.png": 691,
	"./box-prices/box-prices-hero.jpg": 692,
	"./box-prices/couples-box.jpg": 802,
	"./box-prices/family-box.jpg": 803,
	"./box-prices/four-person-box.jpg": 455,
	"./box-prices/most-popular.png": 693,
	"./box-prices/two-person-box.jpg": 454,
	"./discount-modal-header.jpg": 456,
	"./earn-reward-background.jpg": 804,
	"./five-recipes/five-recipes.png": 603,
	"./gousto-boxes.jpg": 604,
	"./gousto-welcome-journey-rollover.jpg": 805,
	"./hungry-for-savings.png": 806,
	"./menu/FebYouary_desktop.jpg": 807,
	"./menu/FebYouary_mobile.jpg": 808,
	"./menu/FebYouary_tablet.jpg": 809,
	"./menu/default_desktop_no_click.png": 810,
	"./menu/default_mobile_no_click.png": 811,
	"./menu/default_tablet_no_click.png": 812,
	"./menu/spottyTileBorder.png": 605,
	"./my-gousto-pricing-modal.svg": 813,
	"./pause-osr-modal-bg.jpg": 814,
	"./product-placeholder.png": 457,
	"./recipe-placeholder.png": 303,
	"./red-rice-pattern.png": 458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 568;